import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import AccountMenuItem from './AccountMenuItem';
import FeedbackModal from '../../FeedbackModal';
import { locales } from '../../../utils/formatters';

function AccountMenuNavigation({
	isMobile,
	isImpersonating,
	canSendFeedback = true,
	theme,
	t,
	currentUser = undefined,
	onNavigateMyAccount,
	onNavigateContactUs,
	onNavigateImpersonateCustomers,
}) {
	const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

	const handleOpenFeedback = () => setIsFeedbackOpen(true);
	const handleCloseFeedback = () => setIsFeedbackOpen(false);

	const visibilityContext = {
		isImpersonating,
		canSendFeedback,
	};

	const itemDefinitions = [
		{
			key: 'my-account',
			label: t('my_account'),
			icon: <PersonOutlineIcon fontSize="small" />,
			onClick: onNavigateMyAccount,
			isVisible: () => true,
		},
		{
			key: 'contact-us',
			label: t('contact_us'),
			icon: <MailOutlineIcon fontSize="small" />,
			onClick: onNavigateContactUs,
			isVisible: () => true,
		},
		{
			key: 'impersonate',
			label: t('title'),
			icon: <GroupsIcon fontSize="small" />,
			onClick: onNavigateImpersonateCustomers,
			isVisible: ({ isImpersonating: currentlyImpersonating }) =>
				!currentlyImpersonating,
		},
		{
			key: 'feedback',
			label: t('feedback'),
			icon: <RateReviewOutlinedIcon fontSize="small" />,
			onClick: handleOpenFeedback,
			isVisible: () => canSendFeedback,
		},
	];

	const items = itemDefinitions.filter((item) =>
		typeof item.isVisible === 'function'
			? item.isVisible(visibilityContext)
			: true
	);

	return (
		<>
			<Box paddingTop={2} paddingBottom={2}>
				{items.map((item) => (
					<AccountMenuItem
						key={item.key}
						isMobile={isMobile}
						theme={theme}
						label={item.label}
						icon={item.icon}
						onClick={item.onClick}
						withTopOffset={item.withTopOffset}
					/>
				))}
			</Box>
			{canSendFeedback && (
				<FeedbackModal
					open={isFeedbackOpen}
					onClose={handleCloseFeedback}
					locales={locales()}
				/>
			)}
		</>
	);
}

AccountMenuNavigation.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	isImpersonating: PropTypes.bool.isRequired,
	canSendFeedback: PropTypes.bool,
	theme: PropTypes.object.isRequired,
	t: PropTypes.func.isRequired,
	currentUser: PropTypes.object,
	onNavigateMyAccount: PropTypes.func.isRequired,
	onNavigateContactUs: PropTypes.func.isRequired,
	onNavigateImpersonateCustomers: PropTypes.func.isRequired,
};

export default AccountMenuNavigation;
